import React from 'react';
import PropTypes from 'prop-types';
import gettext from '@eb/gettext';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import { loadReCaptcha } from 'react-recaptcha-v3';

import { NotificationBar } from '@eb/eds-notification';
import { withMainControls } from '@eb/eds-structure';

import { ICON_TYPE_PROP_TYPE } from '@eb/eds-icon';
import { TYPE_ERROR } from '@eb/eds-notification';
import { AlertChunky } from '@eb/eds-iconography';
import { User } from '@eb/eds-iconography';

import PageHeader from '../../components/PageHeader';
import LinkedSoftAccountsForm from '../../components/forms/LinkedSoftAccountsForm';
import AuthenticationStructure from '../../components/AuthenticationStructure';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/SET_LINKED_SOFT_ACCOUNTS_PATH
 */
class SetLinkedSoftAccountsPage extends React.PureComponent {
    static propTypes = {
        onLinkedAccountsCreatePassword: PropTypes.func,
        email: PropTypes.string,
        moveBack: PropTypes.func,
        clearAuthNotification: PropTypes.func,
        recaptcha3PublicKey: PropTypes.string,

        disableRecaptcha3: PropTypes.bool,

        onSocialProviderClick: PropTypes.func,
        authNotificationOptions: PropTypes.shape({
            message: PropTypes.node,
            type: PropTypes.string,
            iconType: ICON_TYPE_PROP_TYPE,
        }),
    };

    componentDidMount() {
        if (!this.props.disableRecaptcha3) {
            loadReCaptcha(this.props.recaptcha3PublicKey);
        }
    }

    // Don't have a good understanding of this function yet or when is it necessary.
    forceUpdate(socialProvider, stateFromProvider) {
        const { onSocialProviderClick } = this.props;

        if (onSocialProviderClick) {
            onSocialProviderClick({
                socialProvider,
                stateFromProvider,
            });
        }
    }

    _handleSubmit = (formData) => {
        const {
            clearAuthNotification,
            onLinkedAccountsCreatePassword,
        } = this.props;

        // clear notification everytime form is submitted
        if (clearAuthNotification) {
            clearAuthNotification();
        }

        return onLinkedAccountsCreatePassword(formData);
    };

    _handleShowNotification = (error) => {
        const { addMainNotification } = this.props;

        /*Limit the call to addMainNotification to only if
        a notification hasn't been shown since last submit.*/
        if (!this._hasNotification) {
            addMainNotification({
                type: TYPE_ERROR,
                children: error,
                iconType: <AlertChunky />,
            });

            this._hasNotification = true;
        }
    };

    _renderAuthNotification = () => {
        const { authNotificationOptions } = this.props;

        let component = null;

        if (!isEmpty(authNotificationOptions)) {
            const { message, ...props } = authNotificationOptions;

            component = (
                <div className="eds-l-mar-top-4 eds-l-mar-bot-8 sign-in-screen__notification-container">
                    <NotificationBar {...props}>{message}</NotificationBar>
                </div>
            );
        }

        return component;
    };

    _handleClearNotification = () => {
        const { hideMainNotification } = this.props;

        this._hasNotification = false;
        hideMainNotification && hideMainNotification();
    };

    render() {
        const {
            email,
            moveBack,
            authNotificationOptions,
            socialAuthenticationData,
            clearAuthNotification,
        } = this.props;

        let pageHeaderProps = {
            headerText: gettext('Welcome back'),
            iconType: <User />,
            subtitleText: null,
        };
        const buttonCTA = gettext('Create Password');

        // hide subtitle when an auth notification is being displayed
        if (!isEmpty(authNotificationOptions)) {
            pageHeaderProps = omit(pageHeaderProps, 'subtitleText');
        }

        return (
            <AuthenticationStructure>
                <>
                    <PageHeader {...pageHeaderProps} />

                    {this._renderAuthNotification()}

                    <LinkedSoftAccountsForm
                        buttonCTA={buttonCTA}
                        onSubmit={this._handleSubmit}
                        clearAuthNotification={clearAuthNotification}
                        handleEmailEdit={moveBack}
                        email={email}
                        showNotification={this._handleShowNotification}
                        clearNotification={this._handleClearNotification}
                        socialAuthenticationData={socialAuthenticationData}
                    />
                </>
            </AuthenticationStructure>
        );
    }
}

export default withMainControls(SetLinkedSoftAccountsPage);
